export const useAttentionCardPresenter = (onClick) => {
  const presenter = {
    onHandleClose() {
      onClick();
    },
  };

  return presenter;
};
